import React from 'react';
import { Button, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import buildCsv from '@src/components/export/buildCsv';
import { manualAlertExportConfig } from '@src/components/export/utils';

const buildExportData = ({ columns, alertData, eventsData }) => {
  return {
    sections: {
      alert: {
        alertRow: {
          headers: columns,
          data: alertData,
        },
      },
      events: {
        eventRows: {
          headers: columns,
          data: eventsData,
        },
      },
    },
  };
};

const ExportButton = ({ columns, alertData, eventsData }) => {
  const handleClick = () => {
    const exportData = buildExportData({ columns, alertData, eventsData });
    buildCsv({ config: manualAlertExportConfig, data: exportData });
  };

  return (
    <Space>
      <Button icon={<DownloadOutlined />} onClick={handleClick} />
    </Space>
  );
};

export default ExportButton;
